/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import Footer from '../Footer'

const About = () => {
  return (
    <>
    <div className='big-about-div'>
    <div className='about-acm-div'>
            <h2>Our <span style={{color:"#D79929"}} >Achievements</span></h2><br/>
            <div className="acm-info-img" id='award'>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
  <img 
    src="./Images/award1.jpg" 
    className="acm" 
    style={{
      display: 'block', 
      width: '45%', 
      maxWidth: '1000px', 
      height: 'auto',
      border: '3px solid #000'
    }} 
  />

  <img 
    src="./Images/team/teamphoto.jpeg" 
    className="acm" 
    style={{
      display: 'block', 
      width: '50%', 
      maxWidth: '1000px', 
      height: 'auto',
      border: '3px solid #000'
    }} 
  />
</div>

            <p className='acm-info'>
                  We are proud to announce that our JSPM RSCOE ACM Student Chapter received <strong>"Outstanding Emerging Chapter Award 2022"</strong> from all over India from Association of Computing Machinery (ACM India).
                  We are immensely proud and thrilled to announce that the JSPM RSCOE ACM Student Chapter has been honored with the prestigious "Outstanding Emerging Chapter Award 2022". This recognition was awarded to us by the Association of Computing Machinery (ACM India), acknowledging our exceptional contributions and achievements in the field of computing and technology.

Out of numerous chapters across India, our chapter stood out for its commitment to fostering innovation, learning, and collaboration among students. This award highlights our dedication to advancing the knowledge of computer science, offering unique opportunities for skill development, and promoting an inclusive community for tech enthusiasts.

Receiving this accolade is not only a testament to the hard work and passion of our student members but also an acknowledgment of the collective efforts and support of our faculty advisors and the entire college community. We take immense pride in this achievement and are inspired to continue pushing boundaries in the realm of technology, innovation, and academic excellence.

This award motivates us to strive even further, aiming for greater accomplishments in the years to come, while continuing to create a nurturing environment for the development of future leaders in the field of computing.
                </p>
                
            </div>
        </div>

        <div className='about-acm-div'>
            <h2>About ACM</h2><br/>
            <div className="acm-info-img">
                <img src="./Images/acm.png" className='acm'></img>
                <p className='acm-info' >
                The Association for Computing Machinery (ACM) is a prestigious, US-based international learned society for computing. Founded in 1947 by Richard Hamming, it has since become the world's largest scientific and educational computing society, with nearly 100,000 student and professional members globally, as of 2019. The ACM’s headquarters are located in New York City, and it serves as a central body for academic and scholarly interests in computer science and informatics.
                As a non-profit professional membership organization, ACM provides resources, conferences, journals, and learning opportunities to computing professionals and students alike. Its core mission is to advance computing as both a science and profession, fostering innovation, research, and the development of new technologies across the globe. ACM organizes events like ACM Digital Library, ACM TechTalks, and a range of conferences, connecting like-minded professionals to share knowledge and ideas.
                With a motto of "Advancing Computing as a Science & Profession", ACM plays an instrumental role in setting the standards for computer science education, developing best practices, and enhancing the skill sets of computing professionals worldwide. It is not only a platform for academic growth but also a community that encourages collaboration, learning, and the continuous evolution of the computing field.                </p>
            </div>
        </div>

        <div className='about-acm-div' >
            <h2>About JSPM RSCOE ACM Student Chapter</h2><br/>
            <div className="acm-info-img" id='rscoe-about'>
                <p className='acm-info'>
                The JSPM RSCOE ACM Student Chapter is a student-led organization under the prestigious Association for Computing Machinery (ACM). Our chapter’s mission is to promote ethical computing, advance the state of the art in computer science, and support individuals working in the field. By providing a platform for innovation, we aim to transform creative ideas into practical solutions and encourage students to explore new technologies.

As part of ACM, one of the world's largest and most influential computing associations, we are connected to a global network of professionals and scholars. Our chapter organizes technical workshops, coding challenges, guest lectures, hackathons, and seminars to enrich our members’ learning experiences and foster collaboration. We also engage in academic activities like paper evaluations and committee work, ensuring that we remain at the forefront of research and industry trends.

The JSPM RSCOE ACM Student Chapter is committed to supporting the professional growth of its members through opportunities for career development, networking, and life-long learning. We create an inclusive environment where students can hone their skills, develop leadership qualities, and prepare for success in the fast-paced world of computing.

Through strong leadership, advocacy of high standards, and a focus on collaborative innovation, our chapter amplifies the collective voice of computing professionals, inspiring the next generation of tech leaders to make a lasting impact.               </p>
                <img src="./Images/acmrscoelogo.png" className='acm'></img>
            </div>
        </div>
    </div>

    <Footer />
    </>
  )
}

export default About